
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/devops",
      function () {
        return require("private-next-pages/school/devops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/devops"])
      });
    }
  